import React from "react"
import { Box, componentStyles } from "@mallardbay/lib-react-components"

import OutfitterListings from "~components/pages/outfitter/outfitter-listings"
import OutfitterAbout from "~components/pages/outfitter/outfitter-info/outfitter-about"
import OutfitterInfo from "~components/pages/outfitter/outfitter-info/outfitter-info"
import ResponsiveBlock from "~components/shared/responsive-block"
import OutfitterLodgings from "~components/pages/outfitter/outfitter-lodgings"
import OutfitterGuides from "~components/pages/outfitter/outfitter-guides"
import Divider from "~components/shared/divider"
import OutfitterFeed from "~components/pages/outfitter/outfitter-feed"

export default function OutfitterDetails() {
    const styles = useStyles()

    return (
        <ResponsiveBlock>
            <Box style={styles.root}>
                <Box as="aside" style={styles.aside}>
                    <OutfitterInfo />
                    <OutfitterFeed />
                </Box>
                <Box as="main" style={styles.main}>
                    <OutfitterAbout />
                    <Divider />
                    <OutfitterListings />
                    <Divider />
                    <OutfitterLodgings />
                    <Divider />
                    <OutfitterGuides />
                </Box>
            </Box>
        </ResponsiveBlock>
    )
}

function useStyles() {
    return componentStyles({
        root: {
            marginTop: "24px",
            display: "grid",
            gridTemplateColumns: { base: "100%", md: "33% 66%" },
            gap: "24px",
        },
        aside: {
            position: { md: "sticky" },
            top: { md: "64px" },
            alignSelf: { md: "start" },
        },
        main: {
            display: "flex",
            flexDirection: "column",
            gap: "24px",
        },
    })
}
